export function OutlineGanttIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0226 3H7.94096C7.41076 3 6.98096 3.42981 6.98096 3.96V5.04C6.98096 5.57019 7.41076 6 7.94096 6H11.0226C11.5528 6 11.9826 5.57019 11.9826 5.04V3.96C11.9826 3.42981 11.5528 3 11.0226 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0228 8.00195H11.9444C11.4142 8.00195 10.9844 8.43176 10.9844 8.96195V10.042C10.9844 10.5721 11.4142 11.002 11.9444 11.002H20.0228C20.553 11.002 20.9828 10.5721 20.9828 10.042V8.96195C20.9828 8.43176 20.553 8.00195 20.0228 8.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.021 18H13.941C13.4108 18 12.981 18.4298 12.981 18.96V20.04C12.981 20.5702 13.4108 21 13.941 21H18.021C18.5512 21 18.981 20.5702 18.981 20.04V18.96C18.981 18.4298 18.5512 18 18.021 18Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0226 12.998H7.94096C7.41076 12.998 6.98096 13.4279 6.98096 13.958V15.038C6.98096 15.5682 7.41076 15.998 7.94096 15.998H14.0226C14.5528 15.998 14.9826 15.5682 14.9826 15.038V13.958C14.9826 13.4279 14.5528 12.998 14.0226 12.998Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.98267 3V21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
